import script from "./dx-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./dx-upload.vue?vue&type=script&setup=true&lang=js"

import "./dx-upload.vue?vue&type=style&index=0&id=683a8568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683a8568"]])

export default __exports__